import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getCookie } from '../../utils/cookies-util';
import { SIGNIN_PATH } from '../../constants/admin-paths';
import { userType } from '../../utils';
import { USER_SIGNIN_PATH } from '../../constants/user-paths';

const ProtectedRoute = ({ user, children }) => {
  const validToken = userType() === 'user' ? getCookie('access-token-user') : getCookie('access-token');
  const location = useLocation();
  const isLoggedIn = user && validToken;

  return isLoggedIn ? (
    children
  ) : (
    <Navigate to={userType() === 'user' ? USER_SIGNIN_PATH : SIGNIN_PATH} state={{ from: location }} replace={true} />
  );
};

export default ProtectedRoute;
